import React, { useState } from 'react';
import { Mail } from 'lucide-react';
export function Newsletter() {
  const [email, setEmail] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle submission
    setEmail('');
    alert('Thanks for subscribing!');
  };
  return <section className="py-24 bg-brand-900 text-white" data-id="element-146" data-mp="36pb7vxdffqwi">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-147" data-mp="36puguol3n4ye">
        <Mail className="h-12 w-12 mx-auto text-brand-300 mb-6" data-id="element-148" data-mp="3uggqgkar4xai" />
        <h2 className="text-3xl md:text-4xl font-title font-bold mb-4" data-id="element-149" data-mp="39dyvrr04ozr">
          Want to learn more?
        </h2>
        <p className="text-brand-100 text-lg mb-10 max-w-2xl mx-auto" data-id="element-150" data-mp="3lfa59xx5qyax">
          Subscribe to my newsletter for insights on relationships, mental
          health, and finding meaningful happiness.
        </p>

        <form onSubmit={handleSubmit} className="max-w-md mx-auto flex flex-col sm:flex-row gap-3" data-id="element-151" data-mp="29yaifhtkxboa">
          <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Enter your email address" required className="flex-grow px-6 py-4 rounded-full bg-white/10 border border-white/20 text-white placeholder:text-brand-200 focus:outline-none focus:ring-2 focus:ring-brand-300 focus:bg-white/20 transition-all" data-id="element-152" data-mp="2ezpyevgwgrzt" />
          <button type="submit" className="px-8 py-4 bg-accent-500 text-white rounded-full font-medium hover:bg-accent-600 transition-colors whitespace-nowrap" data-id="element-153" data-mp="3b17mxmmu96nu">
            Subscribe
          </button>
        </form>
      </div>
    </section>;
}